/**
 * Returns true if value is a primitive type (string, number, boolean)
 * @param value
 */
export const isPrimitive = (value: any): boolean => {
  return (typeof value !== 'object' && typeof value !== 'function') || value === null;
};

/**
 * This method add quotes to a URL.
 * Use this EVERY TIME you use the "backgroundImage" prop - there is a bug in styled-component
 * It wraps the url inside url(...) but without using quotes, so if the URL contains parenthesis,
 * it does not work.
 * @param url
 */
export const addQuotes = (url: string): string => `"${url}"`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/utils.ts